import styles from './terms-of-service.module.scss';
import { useEffect, useState } from 'react';
import dbService from 'services/database.service';
import { WCircularProgress } from 'components/wrappers/wrapper';

function TermsPage() {
  const [html, setHtml] = useState<string | null | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dbService.getContent({ filter: { key: 'terms_conditions' } }).then((res) => {
      const data = res?.[0]?.rich_text || null;
      setHtml(data);
      setLoading(false);
    });
  }, []);

  if (loading || html === undefined) {
    return (
      <div>
        <WCircularProgress size={25} className={styles.content_loading} />
      </div>
    );
  }

  return (
    <>
      {html ? (
        <div className={styles.conditions} dangerouslySetInnerHTML={{ __html: html }}></div>
      ) : (
        <div className={styles.error_message}>
          <p>Error: Terms and conditions content is not available. Please try again later.</p>
        </div>
      )}
    </>
  );
}

export default TermsPage;
